(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[662],{

/***/ 78485:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings",
      function () {
        return __webpack_require__(4231);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ settings; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/DashboardLayout/index.tsx + 6 modules
var DashboardLayout = __webpack_require__(79747);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/firebase/auth/FirebaseClaims.tsx
var FirebaseClaims = __webpack_require__(93598);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/data-access/src/generated/index.tsx + 5 modules
var generated = __webpack_require__(20229);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Form/index.tsx
var Form = __webpack_require__(72131);
// EXTERNAL MODULE: ../../libs/pages/src/common/hooks/useVetterDisclaimer.ts
var useVetterDisclaimer = __webpack_require__(42526);
// EXTERNAL MODULE: ../../node_modules/antd/es/form/index.js + 16 modules
var es_form = __webpack_require__(86868);
// EXTERNAL MODULE: ../../node_modules/antd/es/col/index.js
var col = __webpack_require__(3086);
// EXTERNAL MODULE: ../../node_modules/antd/es/row/index.js
var row = __webpack_require__(3306);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/PageCard/index.tsx + 1 modules
var PageCard = __webpack_require__(87586);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/FormItem/index.tsx + 3 modules
var FormItem = __webpack_require__(74606);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(81824);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Space/styles.ts
var styles = __webpack_require__(81983);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx
var Typography_styles = __webpack_require__(93430);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/theme.ts
var theme = __webpack_require__(32657);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Call.js
var Call = __webpack_require__(18869);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/antd/es/avatar/index.js + 5 modules
var avatar = __webpack_require__(54371);
// EXTERNAL MODULE: ../../node_modules/antd/es/button/index.js
var es_button = __webpack_require__(24832);
// EXTERNAL MODULE: ../../node_modules/antd/es/typography/index.js + 19 modules
var typography = __webpack_require__(8722);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/applicant/InterviewButton/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(81, 213, 19, 0.7);\n  }\n  \n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 10px rgba(81, 213, 19, 0);\n  }\n  \n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(81, 213, 19, 0);\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: ",
        ";\n  position: relative;\n  display: flex;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 12px;\n  margin-right: 22px;\n  position: relative;\n\n  & svg {\n    position: relative;\n    box-shadow: 0 0 0 0 rgba(81, 213, 19, 1);\n    animation: ",
        " 2s infinite;\n    top: 22px;\n    left: 26px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 48px;\n  height: 48px;\n  position: absolute;\n  left: 0;\n  top: -12px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            width: 48px;\n            height: 48px;\n          "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            width: 36px;\n            height: 36px;\n          "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border: none;\n  display: flex;\n  color: ",
        ";\n  background: ",
        ";\n  height: min-content;\n  min-height: 72px;\n  min-width: 335px;\n  box-shadow: 12px 24px 48px -12px rgba(0, 95, 249, 0.25);\n\n  justify-content: ",
        ";\n  align-items: center;\n  text-align: left;\n\n  font-weight: 600;\n  font-size: ",
        ";\n\n  &.ant-btn-primary:hover {\n    background: ",
        ";\n    color: ",
        ";\n    filter: brightness(1.1);\n  }\n\n  &.ant-btn > span {\n    align-self: center;\n    width: 100%;\n  }\n\n  &.ant-btn-primary:focus,\n  :active {\n    background: #1840da;\n    color: ",
        ";\n  }\n\n  &.ant-btn-primary[disabled] {\n    box-shadow: 12px 24px 48px -12px rgba(0, 95, 249, 0.25);\n    background: ",
        ";\n    color: ",
        ";\n    && svg {\n      opacity: 0.7;\n      background: ",
        ";\n    }\n  }\n\n  & svg {\n    color: ",
        ";\n    font-size: 18px;\n    ",
        ";\n\n    position: relative;\n    background: #51d513;\n    border-radius: 50%;\n    padding: 11px;\n    font-size: 30px;\n  }\n\n  &.ant-btn-primary[disabled] svg {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: pre-wrap;\n  margin: 23px 4px 22px 18px;\n  max-width: 292px;\n\n  @media (max-width: 576px) {\n    margin-left: 18px;\n    margin-right: 12px;\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-top: 12px;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &,\n  &.ant-typography,\n  .ant-typography &,\n  &.ant-typography:active,\n  .ant-typography &:active,\n  &.ant-typography:hover,\n  .ant-typography &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: rotate(52deg);\n  }\n  100% {\n    transform: rotate(412deg);\n  }\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  border-top: 30px solid ",
        ";\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  top: 0;\n  left: 0;\n  transform: rotate(52deg);\n\n  animation: ",
        " 2s linear infinite;\n  z-index: 0;\n  margin-left: -3px;\n  margin-top: -3px;\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}




const pulseGreen = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
const LoadingIconWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), (param)=>{
    let { lookingForVetter  } = param;
    return lookingForVetter ? "8px" : "-48px";
});
const IconWithPhotoWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), pulseGreen);
const Avatar = (0,styled_components_browser_esm/* default */.ZP)(avatar/* default */.C)(_templateObject3());
const styles_Button = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z)(_templateObject6(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { $submitting , theme  } = param;
    return $submitting ? "linear-gradient(277.66deg, rgba(255, 255, 255, 0.2) 38.81%, rgba(255, 255, 255, 0) 71.73%), rgba(0, 95, 249, 0.97)" : theme.colors.blue60;
}, (param)=>{
    let { $submitting  } = param;
    return $submitting ? "left" : "center";
}, (param)=>{
    let { $submitting  } = param;
    return $submitting ? "15px" : "18px";
}, (param)=>{
    let { theme  } = param;
    return theme.colors.blue60;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.grey30;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.grey40;
}, (param)=>{
    let { color , theme  } = param;
    return color ? color : theme.colors.white;
}, (param)=>{
    let { $iconSize  } = param;
    switch($iconSize){
        case "large":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
        default:
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
    }
}, (param)=>{
    let { theme  } = param;
    return theme.colors.grey30;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white;
});
const InnerWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7());
const Text = (0,styled_components_browser_esm/* default */.ZP)(Typography_styles/* Text */.xv)(_templateObject8(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey40;
});
const Typography = (0,styled_components_browser_esm/* default */.ZP)(typography/* default */.Z)(_templateObject9());
const ExplanationLink = (0,styled_components_browser_esm/* default */.ZP)((link_default()))(_templateObject10(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey40;
});
const spin = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject11());
const RotatingBorder = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, spin);

// EXTERNAL MODULE: ../../libs/common-utils/src/env.ts
var env = __webpack_require__(70800);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/applicant/InterviewButton/config.tsx







const TWILIO_PHONE_NUMBER = env.checkEnvVarValue("+13103611235");
const EXPLANATIONS = {
    INTERVIEW_NOW: (param)=>/*#__PURE__*/ {
        let { isPredemo  } = param;
        return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                'This call may be recorded for quality and training purposes. By clicking "',
                isPredemo ? "Connect Now" : "Interview Now",
                '" you accept the',
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExplanationLink, {
                    href: "/terms",
                    target: "__blank",
                    children: "terms and conditions"
                }),
                " ",
                "and",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExplanationLink, {
                    href: "/privacy",
                    target: "__blank",
                    children: "privacy policy"
                }),
                "."
            ]
        });
    },
    INTERVIEWING: (param)=>{
        let { isPredemo  } = param;
        return "".concat(isPredemo ? "We'll be" : "Your interviewer will be", ' calling you shortly, please make sure your phone is not on "do not disturb".\nGood luck you\'ve got this!');
    }
};
const stateCopy = {
    disabled: {
        explanation: EXPLANATIONS.INTERVIEW_NOW,
        text: (param)=>{
            let { isPredemo  } = param;
            return isPredemo ? "Connect Now" : "Interview Now";
        }
    },
    enabled: {
        explanation: EXPLANATIONS.INTERVIEW_NOW,
        text: (param)=>{
            let { isPredemo  } = param;
            return isPredemo ? "Connect Now" : "Interview Now";
        }
    },
    "looking-for-vetter": {
        explanation: EXPLANATIONS.INTERVIEWING,
        text: (param)=>{
            let { isPredemo  } = param;
            return isPredemo ? "Hang tight, get comfortable while we connect you to Vette…" : "Hang tight, get comfortable while we search for your interviewer…";
        }
    },
    "found-vetter": {
        explanation: EXPLANATIONS.INTERVIEWING,
        text: (param)=>{
            let { vetter , timerNode  } = param;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(styles/* Space */.T, {
                direction: "vertical",
                size: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_styles/* Text */.xv, {
                        $size: 15,
                        $color: theme/* theme.colors.white */.r.colors.white,
                        $weight: 400,
                        children: [
                            vetter === null || vetter === void 0 ? void 0 : vetter.firstName,
                            " will be calling",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_styles/* Text */.xv, {
                                $size: 15,
                                $color: theme/* theme.colors.white */.r.colors.white,
                                $weight: 800,
                                children: [
                                    "in ",
                                    timerNode,
                                    " seconds..."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Text */.xv, {
                        $size: 15,
                        $color: theme/* theme.colors.white */.r.colors.white,
                        $weight: 400,
                        children: TWILIO_PHONE_NUMBER
                    })
                ]
            });
        }
    }
};

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/applicant/InterviewButton/index.tsx





const InterviewButton = (param)=>{
    let { state , vetter , timerNode , onClick: originalOnClick , hideDisclaimer , isPredemo , ...buttonProps } = param;
    const noop = (0,react.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
    }, []);
    const styledInterviewProps = (0,react.useMemo)(()=>{
        const disabled = state === "disabled";
        const $submitting = state === "looking-for-vetter" || state === "found-vetter";
        const $iconSize = state === "looking-for-vetter" ? "large" : "medium";
        const onClick = $submitting ? noop : originalOnClick;
        const lookingForVetter = state === "looking-for-vetter";
        const icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: state === "found-vetter" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconWithPhotoWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                        src: vetter === null || vetter === void 0 ? void 0 : vetter.photoLowUrl,
                        alt: "Vetter's profile picture"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Call/* default */.Z, {})
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoadingIconWrapper, {
                lookingForVetter: lookingForVetter,
                children: [
                    lookingForVetter && /*#__PURE__*/ (0,jsx_runtime.jsx)(RotatingBorder, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Call/* default */.Z, {})
                ]
            })
        });
        return {
            disabled,
            $submitting,
            $iconSize,
            onClick,
            icon
        };
    }, [
        state,
        noop,
        originalOnClick,
        vetter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Button, {
                block: true,
                htmlType: "submit",
                type: "primary",
                ...styledInterviewProps,
                ...buttonProps,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerWrap, {
                    children: stateCopy[state].text({
                        vetter,
                        timerNode,
                        isPredemo
                    })
                })
            }),
            !hideDisclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    type: "secondary",
                    children: stateCopy[state].explanation({
                        isPredemo
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/UploadProfilePhotoModal/UploadDropPhoto/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 40px;\n  min-width: 676px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-color: ",
        ";\n      background-color: ",
        ";\n    "
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-height: 386px;\n  border: 1px dashed ",
        ";\n  border-radius: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n\n  ",
        "\n\n  & > .ant-row {\n    height: 100%;\n  }\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 142px;\n  display: flex;\n  justify-content: center;\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n  color: ",
        ";\n"
    ]);
    styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject6 = function() {
        return data;
    };
    return data;
}


const Wrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject());
const DropZone = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey50;
}, (param)=>{
    let { $isActive , theme  } = param;
    return $isActive && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject1(), theme.colors.yellow60, theme.colors.yellow10);
});
const StatusColumnWrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject3());
const Icon = styled_components_browser_esm/* default.img */.ZP.img(styles_templateObject4());
const TextLink = (0,styled_components_browser_esm/* default */.ZP)(Typography_styles/* Text */.xv)(styles_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey50;
});
const PreviewWrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject6());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/UploadProfilePhotoModal/UploadDropPhoto/UploadPreview.tsx




const UploadPreview = (param)=>{
    let { firstName , photo  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InterviewButton, {
            hideDisclaimer: true,
            state: "found-vetter",
            vetter: {
                firstName: firstName || "Helen",
                photoLowUrl: photo || "/images/avatar.svg"
            },
            timerNode: 30
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/CheckCircle.js
var CheckCircle = __webpack_require__(43589);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Cancel.js
var Cancel = __webpack_require__(43749);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/UploadProfilePhotoModal/UploadDropPhoto/UploadStatusColumn.tsx







const UploadStatusColumn = (param)=>{
    let { status  } = param;
    switch(status){
        case "complete":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusColumnWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Space */.T, {
                    direction: "vertical",
                    align: "center",
                    size: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                            htmlColor: theme/* theme.colors.green40 */.r.colors.green40
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Space */.T, {
                            direction: "vertical",
                            align: "center",
                            size: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Title */.Dx, {
                                    level: 3,
                                    children: "Complete"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Text */.xv, {
                                    $size: 12,
                                    $color: theme/* theme.colors.grey50 */.r.colors.grey50,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink, {
                                        $weight: 600,
                                        children: "Change photo"
                                    })
                                })
                            ]
                        })
                    ]
                })
            });
        case "error":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusColumnWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Space */.T, {
                    direction: "vertical",
                    align: "center",
                    size: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel/* default */.Z, {
                            htmlColor: theme/* theme.colors.red50 */.r.colors.red50
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Space */.T, {
                            direction: "vertical",
                            align: "center",
                            size: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Title */.Dx, {
                                    level: 3,
                                    children: "Failed"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink, {
                                    $weight: 600,
                                    children: "Try again"
                                })
                            ]
                        })
                    ]
                })
            });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusColumnWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Space */.T, {
            direction: "vertical",
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    src: "/images/add-photo.svg",
                    alt: "Add photo"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Space */.T, {
                    direction: "vertical",
                    align: "center",
                    size: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Title */.Dx, {
                            level: 3,
                            children: "Drag & drop"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_styles/* Text */.xv, {
                            $size: 12,
                            $color: theme/* theme.colors.grey50 */.r.colors.grey50,
                            children: [
                                "your file here, or ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink, {
                                    $weight: 600,
                                    children: "browse"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/react-dropzone/dist/es/index.js + 5 modules
var es = __webpack_require__(23280);
;// CONCATENATED MODULE: ../../libs/frontend-utils/src/fileSize.ts
const megabytesToBytes = (mb)=>mb * 1024 * 1024;
const bytesToKiloBytes = (bytes)=>bytes / 1024;

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/UploadProfilePhotoModal/UploadDropPhoto/validation.ts

const MAX_FILE_SIZE = megabytesToBytes(20);
const ALLOWED_FORMATS = [
    "jpeg",
    "jpg",
    "png",
    "gif",
    "webp",
    "heic",
    "heif"
];
const supportedFormats = ALLOWED_FORMATS.join(", ").toUpperCase();
const validate = async (acceptedFiles)=>{
    if (acceptedFiles.length > 1) {
        return "Oops! It looks like you're trying to upload more than one image. Please select only one image file to upload.";
    }
    const [file] = acceptedFiles;
    if (file.size > MAX_FILE_SIZE) {
        return "The uploaded file is too large (".concat(Math.floor(bytesToKiloBytes(file.size)), "KB). The maximum file size is ").concat(Math.floor(bytesToKiloBytes(MAX_FILE_SIZE)), "KB.");
    }
    if (!ALLOWED_FORMATS.some((format)=>"image/".concat(format) === file.type)) {
        return "The uploaded file has an incorrect format. The supported formats are: ".concat(supportedFormats, ".");
    }
    return;
};

// EXTERNAL MODULE: ../../node_modules/compressorjs/dist/compressor.js
var compressor = __webpack_require__(55650);
var compressor_default = /*#__PURE__*/__webpack_require__.n(compressor);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/UploadProfilePhotoModal/UploadDropPhoto/utils.ts

const compressionSettings = {
    photoLow: {
        quality: 0.9,
        maxHeight: 150,
        maxWidth: 150,
        mimeType: "image/webp"
    },
    photoHigh: {
        quality: 0.9,
        maxHeight: 1200,
        maxWidth: 1600,
        mimeType: "image/webp"
    }
};
const appleFormatToJPG = async (file)=>{
    const blob = new Blob([
        file
    ], {
        type: "image/heic"
    });
    const nameParts = file.name.split(".");
    nameParts.pop();
    const namePart = nameParts.join();
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const heicConvert = __webpack_require__(79492);
    const img = await heicConvert({
        blob,
        toType: "image/jpeg",
        quality: 0.92
    });
    return new File([
        img
    ], "".concat(namePart, ".jpg"), {
        type: "image/jpeg"
    });
};
const promisifiedCompress = async (file, options)=>{
    return new Promise((resolve, reject)=>{
        new (compressor_default())(file, {
            ...options,
            success (result) {
                resolve(result);
            },
            error (err) {
                reject(err);
            }
        });
    });
};
const compressImage = async (file)=>{
    const [photoLow, photoHigh] = await Promise.all([
        promisifiedCompress(file, compressionSettings.photoLow),
        promisifiedCompress(file, compressionSettings.photoHigh)
    ]);
    return {
        photoLow,
        photoHigh
    };
};
const fileToUrl = (file)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            resolve(reader.result);
        };
        reader.onerror = ()=>{
            reject(reader.error);
        };
        reader.readAsDataURL(file);
    });
};

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/UploadProfilePhotoModal/UploadDropPhoto/index.tsx











const UploadDropPhoto = (param)=>{
    let { firstName , photoUrl , onDrop  } = param;
    const [error, setError] = (0,react.useState)();
    const { getRootProps , getInputProps , isDragActive , isFocused , isFileDialogActive  } = (0,es/* useDropzone */.uI)({
        onDrop: async (acceptedFiles)=>{
            onDrop(undefined);
            const error = await validate(acceptedFiles);
            if (error) {
                setError(error);
                return;
            }
            setError(undefined);
            let [file] = acceptedFiles;
            if (file.type.includes("heic") || file.type.includes("heif")) {
                file = await appleFormatToJPG(file);
            }
            const [{ photoLow , photoHigh  }, url] = await Promise.all([
                compressImage(file),
                fileToUrl(file)
            ]);
            onDrop({
                photoLow,
                photoHigh,
                photoOriginal: {
                    file,
                    url
                }
            });
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropZone, {
                ...getRootProps(),
                $isActive: isDragActive || isFocused || isFileDialogActive,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ...getInputProps()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        gutter: 107,
                        justify: "center",
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadStatusColumn, {
                                    status: error ? "error" : photoUrl ? "complete" : "initial"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadPreview, {
                                    firstName: firstName,
                                    photo: photoUrl
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_styles/* Text */.xv, {
                $size: 9,
                $color: theme/* theme.colors.grey50 */.r.colors.grey50,
                children: [
                    "Maximum upload file size: 20MB. Supports: ",
                    supportedFormats
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Text */.xv, {
                    $size: 9,
                    $color: theme/* theme.colors.red40 */.r.colors.red40,
                    children: error
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../libs/frontend-utils/src/message/index.ts
var message = __webpack_require__(7476);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Modal/index.tsx + 23 modules
var Modal = __webpack_require__(9810);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/UploadProfilePhotoModal/styles.ts

function UploadProfilePhotoModal_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 804px;\n  max-width: 1235px;\n  width: 55vw !important;\n\n  .ant-modal-footer button {\n    flex: 1;\n  }\n\n  .ant-modal-body {\n    text-align: left;\n  }\n"
    ]);
    UploadProfilePhotoModal_styles_templateObject = function() {
        return data;
    };
    return data;
}


const styles_Modal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* Modal */.u)(UploadProfilePhotoModal_styles_templateObject());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/UploadProfilePhotoModal/index.tsx






const UploadProfilePhotoModal = (param)=>{
    let { initialPhotoUrl , firstName , visible , onClose , onUpload  } = param;
    const [data, setData] = (0,react.useState)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Modal, {
        okText: "Upload photo",
        okButtonProps: {
            disabled: !data
        },
        onOk: async ()=>{
            if (!data) return;
            onUpload(data);
            message/* message.success */.y.success("Profile photo has been successfully uploaded. Proceed by saving your settings.");
            setData(undefined);
        },
        cancelText: "Cancel",
        visible: visible,
        onCancel: ()=>{
            setData(undefined);
            onClose();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Space */.T, {
            direction: "vertical",
            size: 64,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Space */.T, {
                    direction: "vertical",
                    align: "start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Title */.Dx, {
                            level: 2,
                            children: "Upload Profile Photo"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_styles/* Text */.xv, {
                            $size: 18,
                            children: [
                                "Uploading a profile photo is required, as it helps the applicant to know they are being connecting with a",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Text */.xv, {
                                    $weight: 600,
                                    $size: 18,
                                    children: "human"
                                }),
                                " ",
                                "for their interview."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadDropPhoto, {
                    firstName: firstName,
                    photoUrl: (data === null || data === void 0 ? void 0 : data.photoOriginal.url) || initialPhotoUrl,
                    onDrop: setData
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Input/index.tsx + 1 modules
var Input = __webpack_require__(68880);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Select/index.tsx + 1 modules
var Select = __webpack_require__(61035);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(92679);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/PhoneAuthenticationForm/AuthForm/index.tsx + 9 modules
var AuthForm = __webpack_require__(72363);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneAuthenticationForm/flows/styles.ts

function flows_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: end;\n"
    ]);
    flows_styles_templateObject = function() {
        return data;
    };
    return data;
}
function flows_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > .ant-modal-content {\n    padding: 20px;\n  }\n"
    ]);
    flows_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function flows_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 12px;\n"
    ]);
    flows_styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const ChangeButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z)(flows_styles_templateObject());
const ChangeModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* SimpleModal */.Y)(flows_styles_templateObject1());
const CloseButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z)(flows_styles_templateObject2());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PhoneAuthenticationForm/flows/UpdatePhoneNumber.tsx









const UpdatePhoneNumber = (param)=>{
    let { settingsForm  } = param;
    const [showModal, setShowModal] = (0,react.useState)(false);
    const [updateUserPhone] = (0,generated/* useUpdateUserPhoneMutation */.nLt)({
        async onCompleted (data) {
            var ref, ref1;
            if (((ref = data.updateUserPhone) === null || ref === void 0 ? void 0 : ref.__typename) === "User") {
                message/* message.destroy */.y.destroy();
                return message/* message.success */.y.success("Your profile was successfully updated.");
            } else if (((ref1 = data.updateUserPhone) === null || ref1 === void 0 ? void 0 : ref1.__typename) === "ValidationError") {
                var ref2;
                message/* message.destroy */.y.destroy();
                return message/* message.error */.y.error((ref2 = data.updateUserPhone) === null || ref2 === void 0 ? void 0 : ref2.messages[0]);
            } else {
                message/* message.error */.y.error("Something went wrong. Our team was notified and is intensively working on fixing the issue.");
            }
        }
    });
    const onSuccess = (user, values)=>{
        updateUserPhone({
            variables: {
                firebaseUid: user.uid,
                phone: values.phone
            }
        });
        settingsForm.setFields([
            {
                name: "phone",
                value: values.phone
            }
        ]);
        setShowModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeButton, {
                actionType: "secondary",
                size: "large",
                onClick: ()=>setShowModal(true),
                "aria-label": "change phone number",
                children: "Change number"
            }),
            showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeModal, {
                visible: true,
                width: 605,
                onCancel: ()=>setShowModal(false),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthForm/* AuthForm */.B, {
                    flow: "changePhone",
                    phoneNumberLabel: "New phone number",
                    onSuccess: onSuccess,
                    header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                flex: "auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Title */.Dx, {
                                    level: 2,
                                    children: "Change phone number"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                flex: "32px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                                    size: "small",
                                    actionType: "tertiary",
                                    onClick: ()=>setShowModal(false),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../libs/frontend-utils/src/hooks/useRole.ts
var useRole = __webpack_require__(21335);
;// CONCATENATED MODULE: ../../libs/frontend-utils/src/hooks/useModalControlProps.ts

const useModalControlProps = function() {
    let initialVisible = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const [visible, setVisible] = (0,react.useState)(initialVisible);
    const open = (0,react.useCallback)(()=>setVisible(true), []);
    const close = (0,react.useCallback)(()=>setVisible(false), []);
    return {
        visible,
        setVisible,
        open,
        close
    };
};

// EXTERNAL MODULE: ../../libs/frontend-utils/src/firebase/messaging.ts + 3 modules
var messaging = __webpack_require__(56284);
;// CONCATENATED MODULE: ../../libs/pages/src/common/Settings/SettingsForm/constants.ts
const residences = [
    "Alabama",
    "Alaska",
    "American Samoa",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "District Of Columbia",
    "Federated States Of Micronesia",
    "Florida",
    "Georgia",
    "Guam",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Marshall Islands",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Northern Mariana Islands",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Palau",
    "Pennsylvania",
    "Puerto Rico",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virgin Islands",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming"
];

// EXTERNAL MODULE: ../../node_modules/antd/es/tag/index.js + 1 modules
var tag = __webpack_require__(61382);
// EXTERNAL MODULE: ../../node_modules/antd/es/switch/index.js + 1 modules
var es_switch = __webpack_require__(49783);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/DeleteOutline.js
var DeleteOutline = __webpack_require__(50334);
;// CONCATENATED MODULE: ../../libs/pages/src/common/Settings/SettingsForm/styles.ts

function SettingsForm_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 36px;\n"
    ]);
    SettingsForm_styles_templateObject = function() {
        return data;
    };
    return data;
}
function SettingsForm_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  gap: 12px;\n  flex-direction: column;\n  margin-bottom: 30px;\n\n  &:nth-child(3) {\n    margin-bottom: 18px;\n  }\n"
    ]);
    SettingsForm_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function SettingsForm_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  height: 100vh;\n"
    ]);
    SettingsForm_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function SettingsForm_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 20px;\n"
    ]);
    SettingsForm_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function SettingsForm_styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        "px;\n  margin-bottom: 0;\n"
    ]);
    SettingsForm_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function SettingsForm_styles_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 18px;\n"
    ]);
    SettingsForm_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function SettingsForm_styles_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  border: none;\n  background: ",
        ";\n  padding: 1px 8px;\n  font-weight: 600;\n  margin: 0;\n"
    ]);
    SettingsForm_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    styles_templateObject8 = function() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-top: 12px;\n"
    ]);
    styles_templateObject9 = function() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: inline;\n  font-size: inherit;\n  height: auto;\n  padding: inherit;\n  line-height: inherit;\n  font-weight: inherit;\n\n  &.ant-btn > span {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    styles_templateObject10 = function() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 15px;\n\n  &.ant-switch-disabled {\n    opacity: 1;\n  }\n"
    ]);
    styles_templateObject11 = function() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      cursor: pointer;\n      border-style: dashed;\n    "
    ]);
    styles_templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 403px;\n  border: 1px solid ",
        ";\n  border-radius: 18px;\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  gap: 12px;\n  justify-content: space-between;\n\n  ",
        "\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n  height: 12px;\n  text-decoration: underline !important;\n  background: none !important;\n  padding: 0;\n"
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n"
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}





const Content = styled_components_browser_esm/* default.div */.ZP.div(SettingsForm_styles_templateObject());
const Section = styled_components_browser_esm/* default.div */.ZP.div(SettingsForm_styles_templateObject1());
const styles_Form = (0,styled_components_browser_esm/* default */.ZP)(Form/* Form */.l)(SettingsForm_styles_templateObject2());
const TitleRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(SettingsForm_styles_templateObject3());
const Row = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(SettingsForm_styles_templateObject4(), (param)=>{
    let { $marginTop  } = param;
    return $marginTop ? $marginTop - 12 : null;
});
const StripeCol = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z)(SettingsForm_styles_templateObject5());
const StatBadge = (0,styled_components_browser_esm/* default */.ZP)(tag/* default */.Z)(SettingsForm_styles_templateObject6(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.green40;
});
const FullWidthFormItem = (0,styled_components_browser_esm/* default */.ZP)(FormItem/* FormItem */.x)(styles_templateObject7());
const DisclaimerText = (0,styled_components_browser_esm/* default */.ZP)(Typography_styles/* Text */.xv)(styles_templateObject8(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey40;
});
const DisclaimerTypography = (0,styled_components_browser_esm/* default */.ZP)(typography/* default */.Z)(styles_templateObject9());
const DisclaimerButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z)(styles_templateObject10(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey40;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.grey40;
});
const NotificationSwitch = (0,styled_components_browser_esm/* default */.ZP)(es_switch/* default */.Z)(styles_templateObject11());
const AvatarWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject13(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey20;
}, (param)=>{
    let { $isEmpty  } = param;
    return $isEmpty && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject12());
});
const UploadButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z)(_templateObject14(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey100;
});
const styles_Avatar = (0,styled_components_browser_esm/* default */.ZP)(avatar/* default */.C)(_templateObject15());
const DeleteIcon = (0,styled_components_browser_esm/* default */.ZP)(DeleteOutline/* default */.Z)(_templateObject16(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey40;
});

;// CONCATENATED MODULE: ../../libs/pages/src/common/Settings/SettingsForm/index.tsx









const SettingsForm = (param)=>{
    let { userId , form , onSubmit , initialValues , submitting , pushNotificationsEnabled  } = param;
    const photo = es_form/* default.useWatch */.Z.useWatch("photoOriginal", form);
    const firstName = es_form/* default.useWatch */.Z.useWatch("firstName", form);
    const { isVetter , isClient , isAdmin , isClientManager  } = useRole/* useRole */.q();
    const { visible , open , close  } = useModalControlProps();
    const [addPushNotificationToken] = (0,generated/* useAddPushNotificationTokenMutation */.la1)({
        optimisticResponse: {
            __typename: "Mutation",
            userAddPushNotificationToken: {
                id: userId,
                pushNotificationsEnabled: true,
                __typename: "User"
            }
        },
        onError: (errors)=>{
            console.error(errors);
            message/* message.error */.y.error("Failed to enable push notifications. Please adjust your browser settings to enable notifications again.");
        }
    });
    const [disablePushNotification] = (0,generated/* useDisablePushNotificationMutation */.N8A)({
        optimisticResponse: {
            __typename: "Mutation",
            userDisablePushNotification: {
                id: userId,
                pushNotificationsEnabled: false,
                __typename: "User"
            }
        },
        onError: (errors)=>{
            console.error(errors);
            message/* message.error */.y.error("Failed to disable push notifications.");
        }
    });
    const onFinish = (values)=>{
        onSubmit({
            ...values
        });
    };
    const updatePushNotificationEnabled = (0,react.useCallback)(async ()=>{
        if (!pushNotificationsEnabled) {
            const token = await messaging/* obtainPushNotificationToken */.A();
            await addPushNotificationToken({
                variables: {
                    userId,
                    token
                }
            });
        } else {
            await disablePushNotification({
                variables: {
                    userId
                }
            });
        }
    }, [
        pushNotificationsEnabled,
        addPushNotificationToken,
        userId,
        disablePushNotification
    ]);
    const mappedInitialValues = (0,react.useMemo)(()=>{
        if (!initialValues) {
            return initialValues;
        }
        return {
            photoOriginal: initialValues.photoOriginalUrl ? {
                url: initialValues.photoOriginalUrl
            } : undefined,
            ...(0,lodash.pick)(initialValues, [
                "firstName",
                "lastName",
                "email",
                "phone",
                "residence"
            ])
        };
    }, [
        initialValues
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Form, {
        form: form,
        onFinish: onFinish,
        initialValues: mappedInitialValues,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageCard/* PageCard */.x, {
            title: "Settings",
            headerActions: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                shouldUpdate: true,
                children: ()=>{
                    var ref, ref1, ref2, ref3;
                    const currentValues = form.getFieldsValue();
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        block: true,
                        size: "large",
                        type: "primary",
                        htmlType: "submit",
                        loading: submitting,
                        disabled: (0,lodash.isEqual)({
                            ...(0,lodash.omit)(currentValues, [
                                "photoOriginal",
                                "photoHigh",
                                "photoLow"
                            ]),
                            photoOriginal: (ref1 = (ref = currentValues.photoOriginal) === null || ref === void 0 ? void 0 : ref.url.split("?")) === null || ref1 === void 0 ? void 0 : ref1[0]
                        }, {
                            ...(0,lodash.omit)(mappedInitialValues, [
                                "photoOriginal"
                            ]),
                            photoOriginal: (ref3 = (ref2 = mappedInitialValues.photoOriginal) === null || ref2 === void 0 ? void 0 : ref2.url.split("?")) === null || ref3 === void 0 ? void 0 : ref3[0]
                        }),
                        children: "Save"
                    });
                }
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                        noStyle: true,
                        ignoreNormalize: true,
                        name: "photoLow"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                        noStyle: true,
                        ignoreNormalize: true,
                        name: "photoHigh"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                        noStyle: true,
                        ignoreNormalize: true,
                        name: "photoOriginal"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadProfilePhotoModal, {
                        firstName: firstName,
                        initialPhotoUrl: photo === null || photo === void 0 ? void 0 : photo.url,
                        onUpload: (uploadData)=>{
                            form.setFieldsValue({
                                photoLow: uploadData.photoLow,
                                photoHigh: uploadData.photoHigh,
                                photoOriginal: uploadData.photoOriginal
                            });
                            close();
                        },
                        visible: visible,
                        onClose: close
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleRow, {
                                justify: "space-between",
                                align: "middle",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Title */.Dx, {
                                    level: 2,
                                    children: "Personal Information"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                gutter: 72,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                        span: 12,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                                gutter: 24,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                        span: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                                                            label: "First name",
                                                            name: "firstName",
                                                            validateTrigger: [
                                                                "onChange"
                                                            ],
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "First name is required"
                                                                }
                                                            ],
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                                                size: "large"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                        span: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                                                            label: "Last name",
                                                            name: "lastName",
                                                            validateTrigger: [
                                                                "onChange"
                                                            ],
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "Last name is required"
                                                                }
                                                            ],
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                                                size: "large"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row, {
                                                gutter: 24,
                                                $marginTop: 24,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                    span: 24,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                                                        noStyle: isClient || isAdmin,
                                                        label: "Residence",
                                                        name: "residence",
                                                        validateTrigger: [
                                                            "onChange"
                                                        ],
                                                        rules: [
                                                            {
                                                                required: isVetter,
                                                                message: "Residence is required"
                                                            }
                                                        ],
                                                        children: isVetter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
                                                            id: "residence",
                                                            option: residences,
                                                            size: "large"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        span: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                                            noStyle: isClientManager,
                                            label: "Profile photo",
                                            name: "photoOriginal",
                                            tooltip: "Upload an image file of type JPG, JPEG, PNG, GIF or WEBP and size less than 20MB.",
                                            rules: [
                                                {
                                                    required: !isClientManager,
                                                    message: "Profile picture is required"
                                                }
                                            ],
                                            ignoreNormalize: true,
                                            children: !isClientManager && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvatarWrapper, {
                                                $isEmpty: !(photo === null || photo === void 0 ? void 0 : photo.url),
                                                onClick: !(photo === null || photo === void 0 ? void 0 : photo.url) ? open : lodash.noop,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                                            align: "middle",
                                                            gutter: 8,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Avatar, {
                                                                        src: (photo === null || photo === void 0 ? void 0 : photo.url) || "/images/avatar.svg"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                                    children: !(photo === null || photo === void 0 ? void 0 : photo.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadButton, {
                                                                        type: "text",
                                                                        children: "Upload"
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Text */.xv, {
                                                                        children: "image.png"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                        children: !!(photo === null || photo === void 0 ? void 0 : photo.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteIcon, {
                                                            onClick: ()=>form.setFieldsValue({
                                                                    photoOriginal: null,
                                                                    photoHigh: null,
                                                                    photoLow: null
                                                                })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleRow, {
                                justify: "space-between",
                                align: "middle",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Title */.Dx, {
                                    level: 2,
                                    children: "Contact Information"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                gutter: 72,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        span: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                                            label: "Email",
                                            name: "email",
                                            validateTrigger: [
                                                "onChange"
                                            ],
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Email address is required"
                                                },
                                                {
                                                    type: "email",
                                                    message: "Must be a valid email address"
                                                }
                                            ],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                                type: "email",
                                                size: "large"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        span: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                            justify: "space-between",
                                            gutter: [
                                                24,
                                                24
                                            ],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                    flex: "auto",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* FormItem */.x, {
                                                        label: "Phone number",
                                                        name: "phone",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                                            size: "large",
                                                            disabled: true
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                    flex: "154px",
                                                    style: {
                                                        alignSelf: "end"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdatePhoneNumber, {
                                                        settingsForm: form
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleRow, {
                                justify: "space-between",
                                align: "middle",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Title */.Dx, {
                                    level: 2,
                                    children: "Notifications"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                                justify: "space-between",
                                align: "bottom",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        flex: "none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationSwitch, {
                                            checked: pushNotificationsEnabled,
                                            onChange: updatePushNotificationEnabled
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        flex: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Title */.Dx, {
                                            level: 5,
                                            children: "Desktop push notifications"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row, {
                                $marginTop: 20,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    span: 8,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styles/* Text */.xv, {
                                        $marginBottom: 20,
                                        children: "Enable notifications if you want us to inform you every time there is an incoming Vette."
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../libs/pages/src/common/Settings/index.tsx








const SettingsPage = (param)=>{
    let { userId  } = param;
    var ref;
    const [form] = Form/* Form.useForm */.l.useForm();
    const { isVetter , isClientInterviewer  } = useRole/* useRole */.q();
    const router = (0,next_router.useRouter)();
    const showDisclaimer = (0,useVetterDisclaimer/* useVetterDisclaimer */.h)();
    const { data , loading  } = (0,generated/* useUserQuery */.bTj)({
        variables: {
            userId
        },
        onCompleted: (param)=>{
            let { user  } = param;
            if ((user === null || user === void 0 ? void 0 : user.__typename) === "User" && isVetter) {
                !(user === null || user === void 0 ? void 0 : user.onboardingCompleted) && router.replace("/terms");
                showDisclaimer(user);
            }
        }
    });
    const [updateUser, { loading: submitting  }] = (0,generated/* useUpdateUserMutation */.kDo)({
        update: (cache)=>{
            cache.evict({
                fieldName: "user"
            });
            cache.evict({
                fieldName: "vetterDashboard"
            });
            cache.evict({
                fieldName: "clientUser"
            });
        },
        onCompleted: (param)=>{
            let { updateUser  } = param;
            if ((updateUser === null || updateUser === void 0 ? void 0 : updateUser.__typename) === "User") {
                var ref;
                const { stripeUser , approvalStatus , photoOriginalUrl  } = updateUser;
                form.setFieldsValue({
                    photoOriginal: photoOriginalUrl ? {
                        url: photoOriginalUrl
                    } : null
                });
                if (isVetter && !(stripeUser === null || stripeUser === void 0 ? void 0 : stripeUser.stripeAccountConnected) || isClientInterviewer && !(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.isProfileDataProvided)) {
                    return showDisclaimer(updateUser, "Thanks for providing your details! ".concat(isVetter ? 'The next step is to go to "Payouts" and click on "Set up your Stripe account" so that you can be paid for your Vettes.' : "You can go online and start Vetting right away!", " ").concat(approvalStatus !== "ACTIVE" ? "Then keep an eye on your texts and emails and we'll let you know as soon as your account is activated to start taking Vettes!" : ""), isClientInterviewer ? 0 : 20);
                }
                showDisclaimer(updateUser, "Settings have been saved.");
            } else if ((updateUser === null || updateUser === void 0 ? void 0 : updateUser.__typename) === "ValidationError") {
                var ref1;
                updateUser === null || updateUser === void 0 ? void 0 : (ref1 = updateUser.messages) === null || ref1 === void 0 ? void 0 : ref1.map((validationError)=>message/* message.error */.y.error(validationError));
            }
        }
    });
    const handleSubmit = async (values)=>{
        var ref;
        if (!userId) {
            return;
        }
        await updateUser({
            variables: {
                userId,
                // omit because we show the button, but we can't edit it (it's a separate flow)
                input: {
                    ...(0,lodash.omit)(values, "phone"),
                    photoOriginal: (ref = values.photoOriginal) === null || ref === void 0 ? void 0 : ref.file
                }
            }
        });
    };
    if (!loading && !(data === null || data === void 0 ? void 0 : data.user)) {
        message/* message.error */.y.error("Something went wrong. Our team was notified and is intensively working on fixing the issue.");
        router.replace("/404");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayout/* DashboardLayout */.c, {
        loading: loading,
        hasStatusToggle: true,
        children: (data === null || data === void 0 ? void 0 : data.user) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsForm, {
            userId: userId,
            form: form,
            onSubmit: handleSubmit,
            submitting: submitting,
            initialValues: data.user,
            stripeAccountConnected: (ref = data.user.stripeUser) === null || ref === void 0 ? void 0 : ref.stripeAccountConnected,
            pushNotificationsEnabled: data.user.pushNotificationsEnabled
        })
    });
};

;// CONCATENATED MODULE: ./pages/settings/index.tsx





const Settings = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FirebaseClaims/* FirebaseClaims */.h, {
            required: {
                id: true
            },
            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayout/* DashboardLayout */.c, {
                loading: true
            }),
            children: (param)=>/*#__PURE__*/ {
                let { id  } = param;
                return (0,jsx_runtime.jsx)(SettingsPage, {
                    userId: id
                });
            }
        })
    });
};
/* harmony default export */ var settings = (Settings);


/***/ }),

/***/ 42526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useVetterDisclaimer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _vette_frontend_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21335);
/* harmony import */ var _vette_frontend_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7476);


const useVetterDisclaimer = ()=>{
    const { isVetter  } = _vette_frontend_utils__WEBPACK_IMPORTED_MODULE_1__/* .useRole */ .q();
    const showAwaitingNotification = (approvalPending)=>approvalPending && isVetter && _vette_frontend_utils__WEBPACK_IMPORTED_MODULE_2__/* .message.info */ .y.info("You are on the waitlist to become a Vetter. We will inform you once your account is approved.", 0);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((param, initialMessage, duration)=>{
        let { approvalStatus , isProfileDataProvided  } = param;
        const approvalPending = !!isProfileDataProvided && approvalStatus !== "ACTIVE";
        _vette_frontend_utils__WEBPACK_IMPORTED_MODULE_2__/* .message.destroy */ .y.destroy();
        initialMessage ? _vette_frontend_utils__WEBPACK_IMPORTED_MODULE_2__/* .message.success */ .y.success({
            content: initialMessage,
            ...duration && {
                duration
            },
            onClose: ()=>showAwaitingNotification(approvalPending)
        }) : showAwaitingNotification(approvalPending);
    }, []);
};


/***/ }),

/***/ 87586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ PageCard; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/ArrowBack.js
var ArrowBack = __webpack_require__(28504);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/next/ClientSide.tsx
var ClientSide = __webpack_require__(50110);
// EXTERNAL MODULE: ../../node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(94187);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx
var styles = __webpack_require__(93430);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(81824);
// EXTERNAL MODULE: ../../node_modules/antd/es/layout/index.js + 9 modules
var layout = __webpack_require__(17332);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PageCard/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow-y: ",
        ";\n  height: ",
        ";\n\n  .ant-layout-header {\n    height: unset;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex: 0 auto;\n  flex-direction: column;\n  padding: 48px 0px 72px;\n  border-radius: 18px;\n  background: ",
        ";\n  margin: 36px;\n  max-height: ",
        ";\n\n  @media print {\n    margin: 4px 0px;\n    padding: 0px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: 888;\n  background: ",
        ";\n  padding: 12px 72px;\n  align-items: center;\n  border-bottom: 1px solid\n    ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 36px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 48px 72px 0;\n  overflow-y: ",
        ";\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media print {\n    display: none;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}



const Layout = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), (param)=>{
    let { $allowScroll  } = param;
    return $allowScroll ? "" : "auto";
}, (param)=>{
    let { $allowScroll  } = param;
    return $allowScroll ? " calc(100vh - 72px)" : "";
});
const Card = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { $allowScroll  } = param;
    return $allowScroll ? "100%" : "";
});
const Header = (0,styled_components_browser_esm/* default */.ZP)(layout/* default.Header */.Z.Header)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme , $showBorder  } = param;
    return $showBorder ? theme.colors.grey20 : "transparent";
});
const HeaderSection = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
const ActionsWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4());
const Content = (0,styled_components_browser_esm/* default */.ZP)(layout/* default.Content */.Z.Content)(_templateObject5(), (param)=>{
    let { $allowScroll  } = param;
    return $allowScroll ? "auto" : "";
});
const BackButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z)(_templateObject6());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/PageCard/index.tsx








const COLLAPSE_THRESHOLD = 84;
const COLLAPSE_THRESHOLD_RESERVE = 12;
const PageCard = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { title , subtitle , hasBackButton , headerActions , children , footer , contentStyle , redirectBackRoute , allowScroll  } = param;
    const router = (0,next_router.useRouter)();
    const scrollRef = react.useRef(null);
    const [showCollapsedHeader, setShowCollapsedHeader] = react.useState(false);
    const handleScroll = (0,react.useCallback)(()=>{
        if (scrollRef.current) {
            const currentScrollY = scrollRef.current.scrollTop;
            // to avoid attaching multiple listeners to scrollRef
            // (react state cannot be used to track the changes here)
            const wentOverThreshold = scrollRef.current.classList.contains("over-threshold");
            if (currentScrollY > COLLAPSE_THRESHOLD && !wentOverThreshold) {
                setShowCollapsedHeader(true);
                scrollRef.current.classList.add("over-threshold");
            } else if (currentScrollY < COLLAPSE_THRESHOLD - COLLAPSE_THRESHOLD_RESERVE && wentOverThreshold) {
                setShowCollapsedHeader(false);
                scrollRef.current.classList.remove("over-threshold");
            }
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (scrollRef.current) {
            scrollRef.current.addEventListener("scroll", handleScroll, {
                passive: true
            });
        }
    }, [
        handleScroll
    ]);
    (0,react.useImperativeHandle)(ref, ()=>({
            scrollToBottom: ()=>{
                if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            },
            scrollToTop: ()=>{
                if (scrollRef.current) scrollRef.current.scrollTop = 0;
            }
        }));
    const handleRedirectBack = ()=>{
        redirectBackRoute ? router.replace(redirectBackRoute) : router.back();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSide/* ClientSide */.B, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
            ref: scrollRef,
            $allowScroll: allowScroll,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                $allowScroll: allowScroll,
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                        $showBorder: showCollapsedHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSection, {
                                children: [
                                    hasBackButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton, {
                                        actionType: "secondary",
                                        size: "large",
                                        onClick: handleRedirectBack,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                                        size: 0,
                                        direction: "vertical",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                level: showCollapsedHeader ? 2 : 1,
                                                children: title
                                            }),
                                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Title */.Dx, {
                                                level: 3,
                                                children: subtitle
                                            })
                                        ]
                                    })
                                ]
                            }),
                            headerActions && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionsWrapper, {
                                children: headerActions
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                        style: contentStyle,
                        $allowScroll: allowScroll,
                        children: children
                    }),
                    footer
                ]
            })
        })
    });
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [517,746,868,675,72,514,984,747,363,774,888,179], function() { return __webpack_exec__(78485); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);